import { render, staticRenderFns } from "./new_password.vue?vue&type=template&id=440bf3d4&"
import script from "./new_password.vue?vue&type=script&lang=js&"
export * from "./new_password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('440bf3d4')) {
      api.createRecord('440bf3d4', component.options)
    } else {
      api.reload('440bf3d4', component.options)
    }
    module.hot.accept("./new_password.vue?vue&type=template&id=440bf3d4&", function () {
      api.rerender('440bf3d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/login/new_password.vue"
export default component.exports